//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'AppMenu',

    props: {
        title: {
            required: true,
            type: String,
        },
        type: {
            required: false,
            type: String,
            default: 'primary',
        },
    },

    data() {
        return {
            open: false,
        };
    },

    mounted() {
        this.$eventBus.on('close-app-menu', this.close);

        document.addEventListener('mousedown', this.handleOutsideClick);
    },

    destroyed() {
        document.removeEventListener('mousedown', this.handleOutsideClick);
    },

    computed: {
        buttonStyle() {
            return {
                primary: 'bg-primary hover:bg-primary-dark text-white font-bold',
                secondary: 'bg-background-primary hover:text-primary font-bold',
                tertiary: 'bg-background-form text-copy-primary hover:text-primary border border-border-form font-bold',
                plain: 'border border-border-form bg-background-form font-normal text-primary',
            }[this.type];
        },
    },

    methods: {
        close() {
            this.open = false;
        },

        handleOutsideClick(event) {
            if (this.open && !this.$refs.dropdown.contains(event.target)) {
                this.close();
            }
        },
    },
};
